import NextLink from 'next/link';

import { Card, formatTimeAgo } from '@frontendmentorio/design-system-v2';

import Activity from 'features/solutions/Activity';
import RetrospectivePreview from 'features/solutions/RetrospectivePreview';
import Tags from 'features/solutions/Tags';
import UserDetails from 'features/learners/UserDetails';

export default function SolutionPreview({ solution }) {
  return (
    <article className="bg-gray-100/50 flex flex-col gap-4 p-5 rounded-xl">
      <div className="flex flex-wrap gap-3 items-center justify-between">
        <UserDetails
          className="mr-auto overflow-x-hidden pt-1"
          user={solution.user}
        />

        <time className="italic text-neutral-500 text-sm">
          Submitted {formatTimeAgo(solution.submittedAt)}
        </time>
      </div>

      <RetrospectivePreview solution={solution} />

      <Card className="flex flex-col mobile:flex-row">
        <Card.Image
          className="flex-shrink-0 mobile:w-1/3 mobile:rounded-bl-xl mobile:rounded-tr-none"
          href={`/solutions/${solution.slug}`}
          src={solution.screenshot}
        />

        <div className="flex flex-col gap-3 min-w-0 p-5">
          <NextLink
            className="hover:underline"
            href={`/solutions/${solution.slug}`}
          >
            <h2 className="font-secondary font-semibold text-xl">
              {solution.title}
            </h2>
          </NextLink>

          <Tags tags={solution.tags} />
          <Activity solution={solution} />
        </div>
      </Card>
    </article>
  );
}
